module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add_bookmark":"Add Bookmark","folder":"Folder","name":"Name","new":"New","add":"Add"},"ja":{"add_bookmark":"ブックマークを追加","folder":"フォルダー","new":"新規","name":"名前","add":"追加"}}')
  delete Component.options._Ctor
}
